import React, { useContext } from "react"
import PropTypes from "prop-types"
import {
  Button,
  TextField,
  Grid,
  Select,
  FormControl,
  InputLabel,
  Typography,
  MenuItem
} from "@material-ui/core"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers"
import { I18nContext } from "translations"
import { PQRS } from "utils/constants"
import schema from "./schema"

const defaultValues = {
  name: "",
  email: "",
  phone: "",
  message: "",
  message_type: "",
  company_name: "",
}

const ContactForm = ({ submit, loading, pqr, isEnabled = false }) => {
  const { translate } = useContext(I18nContext)
  const {
    handleSubmit,
    register,
    errors,
    reset,
    control
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
    mode: "onChange"
  })

  const onSubmit = async (data) => {
    await submit(data)
    reset(defaultValues, { keepIsValid: false })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      {!isEnabled && pqr && (
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginTop: "20px", marginBottom: "10px" }}
        >
          {translate('app.guide.textValidateGuide')}
        </Typography>
      )}

      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <Controller
            control={control}
            name="name"
            label={translate("landing.contact.fullName")}
            defaultValue=""
            as={
              <TextField
                type="text"
                variant="outlined"  
                fullWidth
                size="small"
                error={!!errors.name}
                helperText={errors.name && translate(errors.name.message)}
                disabled={pqr && !isEnabled}
              />
            }
          />
          
        </Grid>
        <Grid item sm={6} xs={12}>
          <Controller
            control={control}
            name="email"
            label={translate("email")}
            defaultValue=""
            as={
              <TextField
                type="text"
                variant="outlined"  
                fullWidth
                size="small"
                error={!!errors.email}
                helperText={errors.email && translate(errors.email.message)}
                disabled={pqr && !isEnabled}
              />
            }
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          {pqr ? (
            <FormControl
              variant="outlined"
              size="small"
              fullWidth
              disabled={pqr && !isEnabled}
            >
            <InputLabel>{translate("pqrs.subject")}</InputLabel>
            <Controller
              control={control}
              name="message_type"
              label={translate("pqrs.subject")}
              variant="outlined"
              defaultValue=""
              as={
                <Select>
                  <MenuItem value="">
                    {translate('app.bookings.filter.choose')}
                  </MenuItem>
                  {PQRS.map((p) => (
                    <MenuItem key={p.value} value={translate(p.name)}>
                      {translate(p.name)}
                    </MenuItem>
                  ))}
                </Select>
              }
            />
          </FormControl>
          ) : (
            <TextField
              name="company_name"
              label={translate("landing.contact.company")}
              type="text"
              inputRef={register}
              variant="outlined"
              size="small"
              fullWidth
              disabled={pqr && !isEnabled}
            />
          )}
        </Grid>
        <Grid item sm={6} xs={12}>
          <Controller
            control={control}
            name="phone"
            label={translate("landing.contact.contactPhone")}
            defaultValue=""
            as={
              <TextField
                type="tel"
                variant="outlined"  
                fullWidth
                size="small"
                error={!!errors.phone}
                helperText={errors.phone && translate(errors.phone.message)}
                disabled={pqr && !isEnabled}
              />
            }
          />
        </Grid>
        {pqr && (
          <Grid item xs={12}>
            <Controller
              control={control}
              name="company_name"
              label={translate("landing.contact.company")}
              defaultValue=""
              as={
                <TextField
                  type="tel"
                  variant="outlined"  
                  fullWidth
                  size="small"
                  disabled={pqr && !isEnabled}
                />
              }
            />
          </Grid>
        )}
        <Grid item xs={12}>
          <Controller
            control={control}
            name="message"
            label={translate("landing.contact.message")}
            defaultValue=""
            as={
              <TextField
                type="text"
                variant="outlined"  
                fullWidth
                size="small"
                error={!!errors.message}
                helperText={errors.message && translate(errors.message.message)}
                disabled={pqr && !isEnabled}
                multiline
                rows={4}
              />
            }
          />
        </Grid>
      </Grid>
      <br />
      <br />
      <Button
        type="submit"
        color="primary"
        variant="contained"
        size="large"
        className="btn-rounded"
        disabled={loading || (pqr && !isEnabled)}
      >
        {translate("landing.contact.send")}
      </Button>
    </form>
  )
}

ContactForm.propTypes = {
  submit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
}

export default ContactForm
